(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var widget = document.getElementById('bopi-calculator');
    if (!widget) return;

    var bitesPerDay = parseFloat(widget.getAttribute('data-bites-per-day')) || 4;
    var patchesPerDay = parseFloat(widget.getAttribute('data-patches-per-day')) || 1;
    var patchesPerPouch = parseFloat(widget.getAttribute('data-patches-per-pouch')) || 24;

    var slider = document.getElementById('calc-days');
    var daysValueEl = document.getElementById('calc-days-value');
    var bitesEl = document.getElementById('calc-bites');
    var patchesEl = document.getElementById('calc-patches');
    var pouchesEl = document.getElementById('calc-pouches');

    var current = { bites: 0, patches: 0, pouches: 0 };

    function animateTo(el, from, to, key) {
      var start = null;
      var duration = 400;

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
        var value = Math.round(from + (to - from) * eased);
        el.textContent = value;
        current[key] = value;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function update() {
      var days = parseInt(slider.value, 10);
      daysValueEl.textContent = days;

      var bites = Math.round(days * bitesPerDay);
      var patches = Math.round(days * patchesPerDay);
      var pouches = Math.max(1, Math.ceil(patches / patchesPerPouch));

      animateTo(bitesEl, current.bites, bites, 'bites');
      animateTo(patchesEl, current.patches, patches, 'patches');
      animateTo(pouchesEl, current.pouches, pouches, 'pouches');
    }

    slider.addEventListener('input', update);
    update();
  });
})();
